import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type React from 'react'
import * as HeaderNavigationSubMenuItemStyles from '../../../../../styles/foundation/HeaderNavigationSubMenuItem.css'
import type { HeaderNavigationSubMenuItemContainerVariants } from '../../../../../styles/foundation/HeaderNavigationSubMenuItem.css'
import { LocalizedLink } from '../../../../ui/v2/LocalizedLink'

type HeaderNavigationSubMenuItemProps = {
  href: string
  isBlank: boolean | null
  type: HeaderNavigationSubMenuItemContainerVariants['type']
  area?: HeaderNavigationSubMenuItemContainerVariants['area']
  children: React.ReactNode
}

export const HeaderNavigationSubMenuItem = ({
  href,
  isBlank,
  type,
  area,
  children,
}: HeaderNavigationSubMenuItemProps) => {
  return (
    <LocalizedLink
      to={href}
      {...(isBlank && { target: '_blank' })}
      rel="noopener"
      className={HeaderNavigationSubMenuItemStyles.Container({
        type: type,
        area: area,
      })}
    >
      {children}
      {type === 'simple' && isBlank && (
        <span className={HeaderNavigationSubMenuItemStyles.Icon}>
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} width="8" />
        </span>
      )}
    </LocalizedLink>
  )
}
